import angular from 'angular';
import directive from './successor.directive';


export default angular.module('app.components.advisory.bcp.successionPlanning.successor', [])
  .directive('bcpSuccessor', directive)
  .name;

console.log('app.components.advisory.bcp.successionPlanning.successor created');
